module.exports = __webpack_public_path__ + "static/media/morning.973e6e7a.svg";